<template>
    <div class='inner'>
        <ul class='banner'>
            <li class='banner-left'><img :src="banner.first" /></li>
            <li class='banner-center'>
                <div class='swiper-main'>
                    <van-swipe ref="swiper" indicator-color="white" class="center-swipe" @change="_swipeChange"
                        :autoplay="8000">
                        <van-swipe-item v-for="x in banner.list" :key='x'>
                            <img :src="x" />
                        </van-swipe-item>
                    </van-swipe>
                </div>
                <div class='swiper-switch left' @click="_swipePrev()"><van-icon name="arrow-left" /></div>
                <div class='swiper-switch right' @click="_swipeNext()"><van-icon name="arrow" /></div>
            </li>
            <li class='banner-right'><img :src="banner.last" /></li>
        </ul>
    </div>
    <div class='inner'>
        <ul class='cont'>
            <li class='cont-left'>
                <van-swipe :show-indicators="false" class='swiper' :autoplay="4000">
                    <van-swipe-item v-for="x in news.images" :key="x.id">
                        <div class='swiper' @click="_clicHref(x)">
                            <span class='pic'><img :src="x.pic" /></span>
                            <span class='txt' v-text="x.title" :title="x.title"></span>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </li>
            <li class='cont-news'>
                <div class='menu'>
                    <span class="active">校园新闻</span>
                </div>
                <div class='list'>
                    <ul v-for="x in news.journalism">
                        <li class='icon'><i></i></li>
                        <li class='title' v-text="x.title" @click="_clicHref(x)" :title="x.title"></li>
                        <li class='date' v-text="_textDate(x.at, 'Y-m-d')"></li>
                    </ul>
                    <ul v-if="news.journalism.length > 5">
                        <li class='more' @click="_clicNewsPath('journalism')"><label>&gt;&gt;</label><span>more</span></li>
                    </ul>
                </div>
            </li>
            <li class='cont-news'>
                <div class='menu'>
                    <span class="active">通知公告</span>
                </div>
                <div class='list'>
                    <ul v-for="x in news.notice">
                        <li class='icon'><i></i></li>
                        <li class='title' v-text="x.title" @click="_clicHref(x)" :title="x.title"></li>
                        <li class='date' v-text="_textDate(x.at, 'Y-m-d')"></li>
                    </ul>
                    <ul v-if="news.notice.length > 5">
                        <li class='more' @click="_clicNewsPath('notice')"><label>&gt;&gt;</label><span>more</span></li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
    <div class='inner'>
        <ul class='cont-service'>
            <li class='item item-01' @click="_clickPath('service/email')">
                <span class='icon'><svg-icon icon-class="x-mailbox" /></span>
                <span class='name'>院长信箱</span>
            </li>
            <li class='item item-02' @click="_clickPathBlank('http://192.168.10.205:11000/#/login')">
                <span class='icon'><svg-icon icon-class="x-electron" /></span>
                <span class='name'>智慧校园</span>
            </li>
            <li class='item item-04' @click="_clickPathBlank('http://192.168.10.211')">
                <span class='icon'><svg-icon icon-class="x-reform" /></span>
                <span class='name'>教学诊改系统</span>
            </li>
            <li class='item item-03' @click="_clickPathBlank('http://113.195.173.106:800/')">
                <span class='icon'><svg-icon icon-class="x-finance" /></span>
                <span class='name'>学生缴费</span>
            </li>
            <li class='item item-05' @click="_clickPathBlank('http://113.195.173.106:10025/jiaowu')">
                <span class='icon'><svg-icon icon-class="x-logistics" /></span>
                <span class='name'>学生成绩查询</span>
            </li>
            <li class='item item-06' @click="_clickPathBlank('http://113.195.173.106:10025/book')">
                <span class='icon'><svg-icon icon-class="x-library" /></span>
                <span class='name'>图书馆</span>
            </li>
        </ul>
    </div>
    <div class='inner'>
        <ul class='sites'>
            <li class='menu'>
                <div class='left'>
                    <span>专题网站</span>
                </div>
                <div class='right'>
                    <span @click="_clickSpecial">MORE</span>
                </div>
            </li>
            <li class='pics'>
                <div class='item' v-for="x in special" @click="_clicHref(x)">
                    <span class='pic'><img :src="x.pic" /></span>
                    <span class='txt' v-text="x.title"></span>
                </div>
            </li>
        </ul>
    </div>
    <div class='inner'>
        <ul class='links' ref='comLinks'>
            <li class='title'>
                <span>友情链接:</span>
            </li>
            <li class='list' ref='comList'>
                <div class='item' v-for="x in links.list">
                    <span class='name' v-text="x.name" @click="_clicLinks(x)"></span>
                    <span class='line'></span>
                </div>
            </li>
            <li class='unfold'>
                <span v-if="!links.show" @click="_viewLinks"><van-icon name="descending" /></span>
                <span v-else @click="_viewLinks"><van-icon name="ascending" /></span>
            </li>
        </ul>
    </div>

    <!--飘窗-->
    <!--      sysConfig.xfk_status === 1-->
    <div v-if="!adStatus">
        <div ref="bayWin" class="bayWin" v-if="show" @mouseenter="mouseenterbayWin" @mouseleave="mouseleavebayWin">
            <a :href="advertisement.location ? advertisement.location : '#'">
                <img :src="'https://www.jxaevc.com' + (advertisement.pics ? advertisement.pics : '')">
            </a>
            <div class="close" @click="closeImg">
                关闭
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import vant from 'vant'
import Mixin from '@/components/common/mixin'

export default {
    name: 'Home',
    components: {

    },
    mixins: [Mixin],
    data() {
        return {
            timeFn: null,
            show: true,
            banner: {
                list: [
                    // '/static/banner/home-00.png',
                    // '/static/banner/home-01.png',
                    // '/static/banner/home-02.png',
                ],
                first: null,//'/static/banner/home-02.png',
                last: null,//'/static/banner/home-01.png'
            },
            news: {
                menu: [
                    { name: '校园新闻', path: 'journalism', css: '' },
                    { name: '通知公告', path: 'notice', css: '' },
                    // {name:'信息公开',path:'open',css:''},
                    // {name:'视频信息',path:'video',css:''},
                ],
                //校园新闻
                journalism: [],
                //通知公告
                notice: [],
                //视频信息
                // video:[],
                //信息公开
                // open:[],
                //当前列表数据
                list: [],
                //当前列表对应地址名称
                path: null,
                //当前列表 -- 图片数据
                images: []
            },
            //专题专栏
            special: [],
            //友情链接
            links: {
                list: [],
                show: false,
            },
            adStatus: true,
            advertisement: {}
        }
    },
    methods: {
        ///////////////////////////////////////////乱翻切换
        _swipePrev() {
            this.$refs.swiper.prev();
        },
        _swipeNext() {
            this.$refs.swiper.next();
        },
        _swipeChange(n) {
            let banner = this.banner;
            let list = banner.list;
            let len = list.length;
            if (n == len) {
                banner.last = list[0];
                banner.first = list[n - 1];
                return;
            }
            if (n == 0) {
                banner.first = list[len - 1];
                banner.last = list[1];
                return;
            }
            banner.last = list[n];
            banner.first = list[n - 1];
        },
        ///////////////////////////////////////////
        _switchNewsSwiper(name) {
            let news = this.news;
            let list = news[name] || [];
            let list_images = [];
            let list_buf = [];
            let len = 0;
            for (let i in list) {
                let v = list[i];
                if (u.isArray(v.pics) && v.pics.length > 0) {
                    v.pic = v.pics.shift();
                }
                if (v.pic) {
                    len++;
                    list_images.push(v);
                } else {
                    list_buf.push(v);
                }
                if (len > 3) {
                    break;
                }
            }
            for (let i = 0; i < (3 - len); i++) {
                let image = list_buf[i] || {};
                image.pic = '/static/default.jpeg'
                list_images.push(image);
            }
            news.images.push(...list_images)
        },
        _pickFilesPic(v) {
            let files = v.files || [];
            for (let i in files) {
                let file = files[i]
                if (/jpg|jpeg|gif|png|bmp$/i.test(file)) {
                    return file;
                }
            }
            return false;
        },
        ///////////////////////////////////////////
        _clickPath(path) {
            u.href(path);
            window.open(x.url, '_bank');
        },
        _clickPathBlank(path) {
            window.open(path, '_bank');
        },
        _clicHref(x) {
            if (x.path == 'news/video') {
                return this._playerVideo(x);
            }
            if (x.location) {
                let location = x.location;
                if (location.indexOf('http') !== 0) {
                    location = 'http://' + location.replace(/^\/+/, '');
                }
                return window.open(location, '_blank');
            }
            u.href(x.path + '/' + x.id)
        },
        _clicNewsPath(path) {
            u.href('news/' + path)
        },
        _playerVideo(x) {
            if (x.link) {
                let link = x.link.indexOf('http') === 0 ? x.link : 'http://' + x.link;
                return window.open(link, '_bank')
            }
            if (!x.files || !u.isArray(x.files)) {
                return;
            }
            let url = x.files[0];
            let node = this.$parent.$parent.$refs.viewVideo;
            node.playerVideo(url);
        },
        _clickSpecial() {
            u.href('special')
        },
        _clicLinks(x) {
            window.open(x.url, '_bank');
        },

        //Banner数据
        _initBanner() {
            u.post('site/banner', {
                path: 'main'
            }, (ret) => {
                if (ret.code != 200) {
                    return;
                }
                let list = ret.list || [];
                if (list.length == 0) {
                    return;
                }
                let banner = this.banner;
                //////////////////////////////////
                banner.list = list
                // if(list.length>2){
                //     this.banner.list = list 
                // }else{
                //     for(let i=0;i<list.length;i++){
                //         banner.list.splice(i,1,list[i]);
                //     }
                // }
                let n = banner.list.length;
                if (n == 1) {
                    banner.first = list[0]
                    banner.last = list[0];
                    return;
                }
                banner.first = list[n - 1];
                banner.last = list[1];
            })
        },
        _viewLinks() {
            let bool = !this.links.show;
            this.links.show = bool;
            let eLinks = this.$refs.comLinks;
            let eList = this.$refs.comList;
            if (bool) {
                eLinks.style.backgroundColor = '#f5f8fa';
                eList.style.height = 'auto';
            } else {
                eList.style.height = '30px';
                eLinks.style.backgroundColor = '';
            }
        },
        //advertisement数据
        _initadvertisement() {
            u.post('site/system', {
                path: 'main'
            }, (ret) => {
                if (ret.code == 200) {
                    if (ret.data.advertisement) {
                        this.adStatus = false;
                        this.advertisement = { ...ret.data.advertisement };
                        this.baywin()
                    }
                }
            })
        },
        /**
     * 飘窗
     * */
        baywin() {
            this.$nextTick(() => {
                if (this.adStatus) {
                    return false
                }
                setTimeout(() => {
                    this.bayNewConfig()
                }, 1000)
            })
        },
        bayNewConfig() {
            let publicityConfig = {
                x: null,
                y: null
            }
            const rootHtml = document.documentElement || document.body
            const interval = 2
            let xDirection = 'positive'
            let yDirection = 'positive'
            publicityConfig.x = Math.floor(Math.random() * (rootHtml.clientWidth - 360) + 360)
            publicityConfig.y = Math.floor(Math.random() * (rootHtml.clientHeight - 302) + 302)
            this.$refs.bayWin.style.top = publicityConfig.y + 'px'
            this.$refs.bayWin.style.left = publicityConfig.x + 'px'
            this.timeFn = () => {
                let x = publicityConfig.x
                let y = publicityConfig.y
                const cW = rootHtml.clientWidth
                const cH = rootHtml.clientHeight
                if (xDirection === 'positive') {
                    if (x + interval >= cW - 360) {
                        x -= interval
                        xDirection = 'inversion'
                    } else {
                        x += interval
                    }
                } else {
                    if (x - interval <= 0) {
                        x += interval
                        xDirection = 'positive'
                    } else {
                        x -= interval
                    }
                }
                if (yDirection === 'positive') {
                    if (y + interval >= cH - 302) {
                        y -= interval
                        yDirection = 'inversion'
                    } else {
                        y += interval
                    }
                } else {
                    if (y - interval <= 0) {
                        y += interval
                        yDirection = 'positive'
                    } else {
                        y -= interval
                    }
                }
                publicityConfig = {
                    x: x,
                    y: y
                }
                this.$refs.bayWin.style.top = publicityConfig.y + 'px'
                this.$refs.bayWin.style.left = publicityConfig.x + 'px'
            }
            this.timer = setInterval(this.timeFn, 20)
        },
        closeImg() {
            this.timer = null
            this.adStatus = true
        },
        mouseenterbayWin() {
            clearInterval(this.timer)
        },
        mouseleavebayWin(e) {
            if (!this.issysStaus) {
                this.timer = setInterval(this.timeFn, 20)
            } else {
                clearInterval(this.timer)
            }
        },
        destroy() {
            clearInterval(this.timer)
            this.timer = null
            this.timeFn = null
        },
        //手机端访问跳转手机站
        linktab() {
            let goUrl = this.isMobile();
            if (goUrl === 1) {
                //移动端地址
                location = "https://www.jxaevc.com/mobile";
            }
        },
        isMobile() {
            let flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            let goUrl = flag ? 1 : 0;
            return goUrl;
        },

    },

    beforeRouteLeave(to, form, next) {
        clearInterval(this.timer)
        next()
    },
    created() {
        //新闻列表数据
        u.post('news/homeList', {}, (ret) => {
            if (ret.code != 200) {
                return;
            }
            let data = ret.data;
            let news = this.news;
            news.journalism = data.journalism || [];
            news.notice = data.notice || [];
            // news.video = data.video || [];
            // news.open = data.open || [];
            //
            this._switchNewsSwiper('journalism');
            // this._switchNewsSwiper('notice');
        }, true);
        //专题数据
        u.post('special/homeList', {}, (ret) => {
            if (ret.code != 200) {
                return;
            }
            this.special = ret.list;
        })
        //链接地址
        u.post('links/homeList', {}, (ret) => {
            if (ret.code != 200) {
                return;
            }
            this.links.list = ret.list;
        });
        /////////////////////////////////////
        this._initBanner();
        //渲染弹窗
        this._initadvertisement();
        //飘窗执行
        // this.baywin();
        //
        this.linktab();

    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/variables.module.scss';
/******************************************************* BANNER ****/
$innerColor: $headerColor;

.inner {
    display: block;
    overflow: hidden;
    width: 100%;
    text-align: center;
}

.banner {
    width: 100%;
    min-width: 1200px;
    max-width: 1920px;
    height: 300px;
    text-align: center;
    overflow: hidden;
    display: inline-block;
    position: relative;
    z-index: 0;
}

.banner .banner-left {
    float: left;
    background-color: #fff;
    width: calc(50% - 600px);
    min-width: 0px;
    height: 100%;
    position: relative;
    z-index: 1;
}

.banner .banner-right {
    float: right;
    background-color: #fff;
    width: calc(50% - 600px);
    min-width: 0px;
    height: 100%;
    position: relative;
    z-index: 2;
}

.banner .banner-left img,
.banner .banner-right img {
    width: none;
    min-width: none;
    height: 100%;
    opacity: 0.5;
}

.banner .banner-center {
    position: relative;
    float: left;
    width: $baseWidth;
    height: 100%;
    z-index: 3;
}

.banner .swiper-main {
    position: relative;
    z-index: 1;
    overflow: hidden;
    display: block;
    width: 100%;
    height: 100%;
}

.banner .swiper-main img {
    /* height:100%;*/
    height: 300px;
    width: 100%;
}

.banner .swiper-switch {
    cursor: pointer;
    position: absolute;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.2);
    width: 56px;
    height: 56px;
    border-radius: 50%;
    top: calc(140px - 20px);
    overflow: hidden;
    display: block;
    color: #fff;
    line-height: 56px;
    font-size: 22px;
}

.banner .swiper-switch:hover {
    background-color: rgba($innerColor, 0.3);
}

.banner .left {
    left: 10px;
}

.banner .right {
    right: 10px;
}

.banner .van-icon {
    font-weight: bolder;
}

/******************************************************* CONT ****/
.cont {
    display: inline-block;
    overflow: hidden;
    width: $baseWidth;
    margin-top: 20px;
    height: 260px;
    font-size: 12px;
}

.cont .cont-left {
    float: left;
    width: 32.5%;
    height: 100%;
}

.cont .cont-left .swiper {
    position: relative;
    height: 100%;
    width: 100%;
    cursor: pointer;
    background-color: #ccc;
}

.cont .cont-left .swiper .pic {
    display: block;
    overflow: hidden;
    position: relative;
    z-index: 1;
    height: 100%;
    width: 100%;
    border-radius: 2px;
}

.cont .cont-left .swiper .pic img {
    height: 100%;
    width: 100%;
}

.cont .cont-left .swiper .txt {
    position: relative;
    z-index: 2;
    display: block;
    overflow: hidden;
    height: 30px;
    line-height: 30px;
    width: 100%;
    text-align: center;
    background-color: rgba(0, 0, 0, .3);
    color: #fff;
    font-size: 12px;
    margin-top: -30px;
}

.cont .cont-left .swiper:hover {
    .pic {
        opacity: 0.8;
    }

    .txt {
        background-color: rgba(0, 0, 0, .2);
    }
}

/*****************************/
.cont .cont-news {
    float: left;
    width: calc(33.75% - 20px);
    margin-left: 20px;
    text-align: left;
}

.cont .cont-news .menu {
    border-top: 1px solid rgba($innerColor, .5);
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    background-color: #f7f7f7;
}

.cont .cont-news .menu span {
    display: block;
    overflow: hidden;
    float: left;
    width: 25%;
    text-align: center;
    color: rgba($innerColor, .8);
    cursor: pointer;
}

.cont .cont-news .menu span:hover {
    background-color: rgba($innerColor, .7);
    color: #fff;
}

.cont .cont-news .menu .active {
    background-color: rgba($innerColor, 1);
    font-weight: bolder;
    color: #fff;
}

.cont .cont-news .menu .active:hover {
    background-color: rgba($innerColor, 1);
    color: #f5f8fa;
}

.cont .cont-news .list {
    display: block;
    overflow: hidden;
    width: 100%;
    padding-top: 13px;
    background-color: #f5f8fa;
}

.cont .cont-news .list ul {
    height: 30px;
    line-height: 30px;
    position: relative;
    color: #7b7b7b;
}

.cont .cont-news .list ul .icon {
    position: absolute;
    display: block;
    overflow: hidden;
    width: 5px;
    height: 5px;
    left: 7px;
    top: 12px;
    /*****************/
    background-color: #b4b4b4;
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0.5);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
}

.cont .cont-news .list ul:hover {
    color: rgba($innerColor, .7);
}

.cont .cont-news .list ul:hover .icon {
    position: absolute;
    z-index: 1;
    display: block;
    width: 6px;
    height: 6px;
    border: 1px solid rgba($innerColor, .7);
    background-color: #fff;
    top: 11px;
    left: 6px;
}

.cont .cont-news .list ul:hover .icon i {
    display: block;
    overflow: hidden;
    width: 2px;
    height: 2px;
    background-color: rgba($innerColor, .7);
    position: relative;
    z-index: 2;
    left: 1px;
    top: 1px;
}

.cont .cont-news .list ul .title {
    float: left;
    position: relative;
    display: block;
    overflow: hidden;
    width: calc(100% - 130px);
    margin-left: 18px;
    font-size: 14px;
    /*-----------------*/
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    cursor: pointer;
}

.cont .cont-news .list ul .date {
    float: right;
    display: block;
    overflow: hidden;
    width: 80px;
    font-size: 12px;
    text-align: right;
    color: #aaa;
    padding-right: 6px;
}

.cont .cont-news .list ul:hover .date {
    color: rgba($innerColor, .7);
}

.cont .cont-news .list ul .more {
    float: right;
    cursor: pointer;
    font-size: 14px;
    margin-right: 8px;
    font-synthesis: 13px;
    display: block;
    overflow: hidden;
    margin-top: -2px;
}

.cont .cont-news .list ul .more span {
    color: rgba($innerColor, 1);
    font-weight: bolder;
    padding-left: 3px;
}

.cont .cont-news .list ul .more:hover span {
    opacity: 0.7;
}

.cont .cont-news .list ul .more label {
    letter-spacing: -2px;
    color: #bbb;
}

.cont .cont-news .list ul .more:hover label {
    color: rgba($innerColor, .5);
}

/*******************************************/
.inner .cont-service {
    display: inline-block;
    overflow: hidden;
    width: $baseWidth;
    margin-top: 15px;
}

.inner .cont-service .item {
    float: left;
    display: block;
    overflow: hidden;
    height: 70px;
    line-height: 70px;
    width: calc(16.6% - 15px);
    margin-left: 15px;
    border: 1px solid #f2eaea;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bolder;
    color: #333;
}

.inner .cont-service .item:first-child {
    margin-left: 0px;
}

.inner .cont-service .item .icon {
    float: left;
    display: block;
    overflow: hidden;
    width: 36%;
    text-align: center;
    font-size: 32px;
}

.inner .cont-service .item .name {
    float: left;
    display: block;
    overflow: hidden;
    width: 64%;
    text-align: left;
    position: relative;
    top: 2px;
    font-size: 15px;
}

/*******************************/
.inner .cont-service .item:hover .icon,
.inner .cont-service .item:hover .name {
    color: #ffffff;
}

.inner .cont-service .item-01 .icon {
    color: #2c77d8;
}

.inner .cont-service .item-01:hover {
    background-color: #2c77d8;
}

.inner .cont-service .item-02 .icon {
    color: #3abaea;
}

.inner .cont-service .item-02:hover {
    background-color: #3abaea;
}

.inner .cont-service .item-03 .icon {
    color: #4ad391;
}

.inner .cont-service .item-03:hover {
    background-color: #4ad391;
}

.inner .cont-service .item-04 .icon {
    color: #eb8d30;
}

.inner .cont-service .item-04:hover {
    background-color: #eb8d30;
}

.inner .cont-service .item-05 .icon {
    color: #42c6cb;
}

.inner .cont-service .item-05:hover {
    background-color: #42c6cb;
}

.inner .cont-service .item-06 .icon {
    color: #c24dd8;
}

.inner .cont-service .item-06:hover {
    background-color: #c24dd8;
}

/******************************************************* SITES ****/
.sites {
    display: inline-block;
    overflow: hidden;
    width: $baseWidth;
    margin-top: 18px;
}

.sites .menu {
    display: block;
    overflow: hidden;
    width: 100%;
    border-bottom: 1px solid rgba($innerColor, .5);
    height: 40px;
    line-height: 40px;
}

.sites .menu .left {
    float: left;
    width: 110px;
    background-color: rgba($innerColor, 1);
    text-align: center;
    font-weight: bolder;
    font-size: 16px;
    color: #fff;
}

.sites .menu .right {
    float: right;
    color: rgba($innerColor, 1);
    font-size: 16px;
    font-weight: bolder;
    cursor: pointer;
    width: 50px;
    text-align: right;
    position: relative;
    top: 2px;
}

.sites .menu .right:hover {
    color: rgba($innerColor, .8);
}

.sites .pics {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 105px;
    margin-top: 18px;
    text-align: left;
}

.sites .pics .item {
    float: left;
    display: block;
    overflow: hidden;
    width: calc(20% - 12px);
    height: 100%;
    margin-left: 15px;
    cursor: pointer;
}

.sites .pics .item:hover {
    opacity: 0.7;
}

.sites .pics .item:first-child {
    margin-left: 0px;
}

.sites .pics .item .pic {
    display: block;
    overflow: hidden;
    height: 85px;
    width: 100%;
}

.sites .pics .item .pic img {
    width: 100%;
    height: 100%;
}

.sites .pics .item .txt {
    display: block;
    overflow: hidden;
    height: 20px;
    line-height: 20px;
    width: 100%;
    text-align: center;
    background-color: #f5f8fa;
    font-size: 12px;
}

/******************************************************* FINKS ****/
.links {
    display: block;
    overflow: hidden;
    margin: 0 auto;
    width: $baseWidth;
    margin-top: 15px;
}

.links .title {
    float: left;
    width: 75px;
    display: block;
    overflow: hidden;
    line-height: 30px;
    text-align: left;
    font-weight: bolder;
    font-size: 16px;
    color: rgba($innerColor, 1);
}

.links .list {
    float: left;
    display: block;
    overflow: hidden;
    height: 30px;
    width: calc(100% - 100px);
    text-align: left;

    .item {
        float: left;
        display: block;
        overflow: hidden;
        font-weight: inherit;

        .name {
            float: left;
            display: block;
            overflow: hidden;
            line-height: 30px;
            color: #535353;
            font-size: 16px;
            cursor: pointer;
        }

        .name:hover {
            color: rgba($innerColor, .8);
        }

        .line {
            float: left;
            display: block;
            overflow: hidden;
            width: 1px;
            height: 12px;
            margin-top: 9px;
            background-color: #999;
            margin-left: 18px;
            margin-right: 18px;
        }
    }

    .item:last-child {
        .line {
            display: none;
        }
    }
}

.links .unfold {
    float: right;
    width: 25px;
    height: 25px;
    display: block;
    overflow: hidden;
    line-height: 30px;
    text-align: right;
    font-weight: bolder;
    font-size: 22px;
    color: #666;
    cursor: pointer;
    position: relative;
    z-index: 9999;
}

.links .unfold:hover {
    color: rgba($innerColor, 1);
}

.links .active {
    color: rgba($innerColor, 1);
    background-color: #f5f8fa;
}
</style>
<style  scoped lang="scss">
.bayWin {
    position: fixed;
    bottom: 0;
    width: 320px;
    height: 135px;
    //overflow: hidden;
    left: -500px;
    z-index: 999999999;

    a {
        display: block;
        width: 320px;
        height: 135px;
        position: relative;

        img {
            width: 320px;
            height: 135px;
        }
    }

    .close {
        cursor: pointer;
        top: -20px;
        right: 0;
        position: absolute;
    }
}
</style>



